import { ExportPayload } from './exportExcel';
import { getProductRegistration } from '../Product/ProductUsers/getProductRegistration';
import { toDefaultDateFormatOrNotAvailable } from 'utils/dateUtils';
import { useProductContext } from '../Product/ProductContext';
import { MontelAccount } from 'domain/account/interfaces';
import { getProductAccessStatusName } from 'domain/product/enums';
import { getProductConfigByName } from 'domain/product/productMap';

export const getProductUserExportPayload = (
	users: MontelAccount[],
): ExportPayload => {
	const { productName } = useProductContext();
	const columns = [
		'Name',
		'Email',
		'Job title',
		'Company',
		'Phone number',
		'Country',
		'Country Iso Code',
		'Date registered (UTC)',
		'Last login (UTC)',
		'Access status',
	];

	const minColumnWidth = 20;

	let nameColumnWidth = minColumnWidth;
	let emailColumnWidth = minColumnWidth;
	let companyColumnWidth = minColumnWidth;
	let phoneColumnWidth = minColumnWidth;
	let countryColumnWidth = minColumnWidth;
	const countryCodeColumnWidth = minColumnWidth;
	const registeredColumnWidth = minColumnWidth;
	const lastLoginColumnWidth = minColumnWidth;
	const accessStatusColumnWidth = minColumnWidth;

	users.forEach((user) => {
		const fullName = `${user.firstName} ${user.lastName}`;

		if (fullName.length > nameColumnWidth) {
			nameColumnWidth = fullName.length;
		}
		if (user.email?.value?.length > emailColumnWidth) {
			emailColumnWidth = user.email.value.length;
		}
		if (user.company?.name?.length > companyColumnWidth) {
			companyColumnWidth = user.company.name.length;
		}
		if (user.phoneNumber && user.phoneNumber?.length > phoneColumnWidth) {
			phoneColumnWidth = user.phoneNumber.length;
		}
		if (
			user.country?.name &&
			user.country?.name.length > countryColumnWidth
		) {
			countryColumnWidth = user.country.name.length;
		}
	});

	const columnWidths = [
		{ wch: nameColumnWidth },
		{ wch: emailColumnWidth },
		{ wch: companyColumnWidth },
		{ wch: phoneColumnWidth },
		{ wch: countryColumnWidth },
		{ wch: countryCodeColumnWidth },
		{ wch: registeredColumnWidth },
		{ wch: lastLoginColumnWidth },
		{ wch: accessStatusColumnWidth },
	];

	const data = [
		columns,
		...users.map((user) => {
			const productRegistration = getProductRegistration(
				user.productRegistrations,
				getProductConfigByName(productName)?.id,
			);

			return [
				`${user.firstName} ${user.lastName}`,
				user.email.value,
				user.company.jobTitle || '',
				user.company.name,
				user.phoneNumber || '',
				user.country?.name || '',
				user.country?.twoLetterIsoCode || '',
				toDefaultDateFormatOrNotAvailable(
					productRegistration?.registeredAt,
				),
				toDefaultDateFormatOrNotAvailable(
					productRegistration?.lastLogin,
				),
				productRegistration?.accessStatus
					? getProductAccessStatusName(
							productRegistration?.accessStatus,
					  )
					: '',
			];
		}),
	];

	return {
		data: data,
		columnWidths: columnWidths,
	};
};
